export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 86.8 94">
  <path fill="${fill? fill : '#5CC4CA'}" 
        d="M86 31.2c-.5-4.8-4.1-11.1-7.9-14 0 0-5.8-4.3-13-8.5-7.2-4.3-13.8-7.2-13.8-7.2C49.1.5 46.2 0 43.4 0c-2.9 0-5.8.5-7.9 1.5 0 0-6.5 2.9-13.8 7.2-7.2 4.3-13 8.5-13 8.5-3.9 2.9-7.4 9.2-7.9 14 0 0-.8 7.2-.8 15.8 0 8.5.8 15.8.8 15.8.5 4.8 4.1 11.1 7.9 14 0 0 5.8 4.3 13 8.6s13.8 7.2 13.8 7.2c2.2 1 5.1 1.5 7.9 1.5 2.9 0 5.8-.5 7.9-1.5 0 0 6.5-2.9 13.8-7.2 7.2-4.3 13-8.6 13-8.6 3.9-2.9 7.4-9.2 7.9-14 0 0 .8-7.2.8-15.8 0-8.5-.8-15.8-.8-15.8zm-4 31.1c-.4 3.8-3.4 9-6.3 11.2-.1 0-5.7 4.2-12.6 8.3-6.9 4.1-13.3 7-13.4 7-1.6.7-3.9 1.1-6.3 1.1s-4.7-.4-6.3-1.1c-.1 0-6.4-2.9-13.4-7-6.9-4.1-12.6-8.3-12.6-8.3-3-2.2-5.9-7.5-6.3-11.2-.1 0-.8-7.1-.8-15.3s.7-15.3.7-15.3c.4-3.8 3.4-9 6.3-11.2.1 0 5.7-4.2 12.6-8.3s13.3-7 13.4-7c1.7-.8 4-1.2 6.4-1.2s4.7.4 6.3 1.1c.1 0 6.4 2.9 13.4 7 6.9 4.1 12.6 8.3 12.6 8.3 3 2.2 5.9 7.5 6.3 11.2 0 .1.7 7.1.7 15.3.1 8.3-.7 15.4-.7 15.4z"/>
  <path fill="${fill? fill : '#5CC4CA'}"  d="M33.2 53h19.1c1.1 0 2-.9 2-2s-.9-2-2-2H33.2c-1.1 0-2 .9-2 2s.9 2 2 2"/>
  <defs>
    <path id="a" d="M33.2 53h19.1c1.1 0 2-.9 2-2s-.9-2-2-2H33.2c-1.1 0-2 .9-2 2s.9 2 2 2"/>
  </defs>
  <clipPath id="b">
    <use xlink:href="#a" overflow="visible"/>
  </clipPath>
  <path clip-path="url(#b)" fill="${fill? fill : '#5CC4CA'}" d="M24.9 42.7h35.7v16.6H24.9z"/>
  <path fill="${fill? fill : '#5CC4CA'}"  d="M54.3 59c0-1.1-.9-2-2-2H33.2c-1.1 0-2 .9-2 2s.9 2 2 2h19.1c1.1 0 2-.9 2-2"/>
  <defs>
    <path id="c" d="M54.3 59c0-1.1-.9-2-2-2H33.2c-1.1 0-2 .9-2 2s.9 2 2 2h19.1c1.1 0 2-.9 2-2"/>
  </defs>
  <clipPath id="d">
    <use xlink:href="#c" overflow="visible"/>
  </clipPath>
  <path clip-path="url(#d)"  fill="${fill? fill : '#5CC4CA'}" d="M24.9 50.7h35.7v16.6H24.9z"/>
  <path fill="none" stroke="${fill? fill : '#5CC4CA'}" stroke-width="4" stroke-linecap="round" stroke-miterlimit="10"
        d="M59.7 67.8H26.2c-.6 0-1-.5-1-1V27.2c0-.6.4-1 1-1h33.5c.6 0 1 .4 1 1v39.5c0 .6-.4 1.1-1 1.1zM36.9 34v8M32.9 38h8"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/uslugas/23.jsx